import script from "./cpt-switch.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-switch.vue?vue&type=script&setup=true&lang=js"

import "./cpt-switch.vue?vue&type=style&index=0&id=149b414c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-149b414c"]])

export default __exports__